<section class="status" [class.status--error]="variant() === 'error'">
  <span class="status__icon" aria-hidden="true"></span>

  @if (heading()) {
    <h1 class="status__title">{{ heading() }}</h1>
  }

  @if (messageHtml(); as html) {
    <div class="status__message" [innerHTML]="html"></div>
  }

  <ng-content />

  @if (actionLabel()) {
    <div class="status__actions">
      <button type="button" class="status__button" (click)="action.emit()">{{ actionLabel() }}</button>
    </div>
  }

  @if (warningHtml(); as html) {
    <div class="status__warning" role="alert" [innerHTML]="html"></div>
  }
</section>
